<template>
  <div class="main-header-collapse m-collapse">
    <div class="cx-wrap--page">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'main-header-collapse',
}
</script>

<style lang="scss">
  // Keep a tunable offset so the dropdown never runs
  // underneath the browser viewport edge.
  // (Header height varies by breakpoint and locale.)
  html.fs-0 { --m-collapse-viewport-offset: 140px; }
  html.fs-1 { --m-collapse-viewport-offset: 140px; }
  html.fs-2 { --m-collapse-viewport-offset: 140px; }

  .m-collapse{
    @include normalize-link($color-white);
    position: absolute;
    width: 100%;
    left: 0;
    z-index: 95;
    top: 100%;
    background-color: rgba($color-green,.95);
    color: mix($color-primary, $color-white, 15%);
    border: none;    
    padding: 2rem 2rem;
    height: auto;
    max-height: calc(100vh - var(--m-collapse-viewport-offset, 140px));
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    // animation: show .3s ease-in-out;
    // @keyframes show {
    //   from {
    //     padding: 0rem 2rem;
    //     max-height: 1px;
    //   }
    //   to {
    //     padding: 2rem 2rem;
    //     max-height: 430px;        
    //   }
    // }
    &__link{
      font-size: $font-xs !important;
      color: $color-white !important;
      font-weight: normal;
      display: flex;
      margin: 5px 0;
      i{
        margin-right: 8px;
        margin-top: 4px;
        opacity: .5;
      }
    }
    &__header{
      @extend %style-subtitle;
      color: $color-white !important;
      font-weight: bold;
      display: block;    
      border-bottom:1px solid mix($color-primary, $color-white, 85%);
      padding-bottom: .8rem;
      margin-bottom: 1rem;

      & > a {
        color: inherit !important;
      }
    }
    &__title{
      color: $color-white !important;
    }
    &__flat{
      color: $color-white;
    }
    &__flex{
      @include set-font(.8);
      display: flex;
      align-items: center;
      margin-right: $space-base;
    }
    &__subtitle{
      @extend %style-subtitle;
      font-weight: normal;
      color: mix($color-primary, $color-white, 30%);
    }
    &__thumb{
      width: 80px;
    }
    &__suggested{
      width: 90%;
      max-width: 250px;
      padding-top: 55%;    
      position: relative;
      background-size: cover;
      background-position: bottom;
      background-repeat: no-repeat;
      margin-bottom: 10px;
    }
    &__graphic{
      position: absolute;
      bottom: 0;
      display: block;
      background-position: bottom;
      background-size: 100%;
      background-repeat: no-repeat;
      pointer-events: none;
    }
    &__experience{
      right:0;
      height: 280px;
      width: 500px;
      display: none!important;
      @media(min-width:992px){
        display: block!important;
      }
    }
    &__planyourtrip{
      left:0;
      height: 280px;
      width: 300px;
      display: none!important;
      background-position: left bottom;
      @media(min-width:992px){
        display: block!important;
      }

      @media(min-width:2000px){
        height: 280px;
        width: 500px;
      }
    }

    // cx-row--nogutter removes grid gutters; inset between columns from the next
    .cx-row--nogutter > [class*='cx-col'] {
      padding-inline-start: $space-base;
      &:first-child {
        padding-inline-start: 0;
      }
    }
  }

  @media (min-width: 2000px) {
    .main-header-collapse.m-collapse {
      min-height: 450px;
    }
  }
</style>
